/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCollisionDeductableOther32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M.5 31h31'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M8.293 27.131c-.774.273-1.033.355-1.777-.082l-.223-.276V29.5a1 1 0 00.999 1h.002a.999.999 0 00.999-1v-2.369z'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M8.5 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24.293 27.131c.774.273 1.034.355 1.777-.082l.223-.276V29.5a1 1 0 01-1 1h-.001a1 1 0 01-.999-.999v-2.369z'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24.09 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M16.293 23.78h-4v-.659A2.12 2.12 0 0114.415 21h3.757a2.12 2.12 0 012.121 2.122v.657h-4z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M19.613 16H8.948a4.449 4.449 0 00-4.443 4.648l.16 3.558a3 3 0 002.997 2.864h17.265a3 3 0 002.997-2.864c.05-1.085.106-2.35.16-3.558A4.448 4.448 0 0023.642 16h-.126M19.984 8.607c2.862.16 4.036.473 4.036.473'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M5.433 18.337l-.001-.001A7.148 7.148 0 015.11 7.272l.88-.763.014.167A2.227 2.227 0 009.83 8.047h0a7.25 7.25 0 001.885-6.441l-.074-.37.415.12a7.94 7.94 0 015.444 9.67M20.953 17.872a3.74 3.74 0 01.542-6.18l.35-.194a4.965 4.965 0 002.466-5.307l.25.151a10.76 10.76 0 015.159 9.188 7.116 7.116 0 01-1.392 4.227l-.18.243'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M13.373 13.859a4.657 4.657 0 00.959-4.87l-.418-1.085a4.735 4.735 0 01-2.181 2.668l-1.145.645a4.723 4.723 0 00-2.4 4.32'
      />
      <path
        fill='currentColor'
        stroke='currentColor'
        strokeWidth={1.5}
        d='M23.656 16.032l-.135-.17.19-.12h0c.335-.21.651-.46.942-.74a7.709 7.709 0 01-.997 1.03z'
      />
    </svg>
  );
}

export default SvgCollisionDeductableOther32;
